// Material
import { Box, IconButton, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { BackButton } from '$common/buttons'
// Icons
// TODO: REPLACE THIS MENU ICON IN USER-LIST-ITEMS
import { MenuIcon, SettingsIcon, EditOutlinedIcon } from '$common/icons'
// Component
import { RoomProfileHeaderInfo } from './room-profile-header-info'
import { ReactNode } from 'react'

interface Props {
  onBack: () => any
  avatarElement: ReactNode
  avatarSrc: string
  primaryText: string
  secondaryText: string | number | JSX.Element
  onMenu?: () => any
  onEdit?: () => any
  onSettings?: () => any
  hasDeleted?: boolean
  avatarBackground?: string
  backgroundColor: string

}

const StyledStack = styled(Stack)<{ backgroundColor?: string }>(({ theme, backgroundColor }) => ({
  overflow: 'hidden',
  height: 129,
  minHeight: 129,
  backgroundColor: backgroundColor ||theme.palette.neutral000,
  borderBottom: '1px solid',
  borderColor: theme.palette.neutral300,
  padding: '7px',
  boxSizing: 'border-box',
  color: backgroundColor
    ? theme.palette.neutral000
    : theme.palette.neutral900,
}))

export function RoomProfileHeader({
  onBack,
  avatarElement,
  avatarSrc,
  primaryText,
  secondaryText,
  onMenu,
  onEdit,
  onSettings,
  hasDeleted = false,
  avatarBackground = '',
  backgroundColor,
}: Props) {
  return (
    <StyledStack backgroundColor={backgroundColor}>
      <Stack direction="row" justifyContent="space-between">
        <BackButton onClick={onBack} color="inherit" />
        <Box>
          {onSettings && (
            <IconButton sx={{ padding: 1 }} onClick={onSettings}>
              <SettingsIcon />
            </IconButton>
          )}
          {onEdit && (
            <IconButton sx={{ padding: 1 }} onClick={onEdit}>
              <EditOutlinedIcon />
            </IconButton>
          )}
          {onMenu && (
            <IconButton
              sx={{ padding: 1 }}
              onClick={onMenu}
            >
              <MenuIcon fill="inherit" />
            </IconButton>
          )}
        </Box>
      </Stack>
      <Box>
        <RoomProfileHeaderInfo
          avatarElement={avatarElement}
          avatarSrc={avatarSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          hasDeleted={hasDeleted}
          avatarBackground={avatarBackground}
          backgroundColor={backgroundColor}
        />
      </Box>
    </StyledStack>
  )
}
